import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDemandServiceListController } from 'src/controllers/DemandService/ListDemandServiceController';
import PrintDemand from '../../controllers/Demands/PrintDemand';
import { ModelOfDemand } from 'src/database';
import DemandController from '../../controllers/Demands/DemandController';

import EditDemand from './EditDemand';
import { useAuth } from 'src/contexts/auth';
import { Toolbar } from 'primereact/toolbar';
import { Link } from 'react-router-dom';


const AbastecimentoList = () => {
    const { getDemandData } = DemandController();
    const { deleteDemand, toast, rejectDemandAdmin } = getDemandData;

    const leftAbastecimentoToolbar = () => {
        return (
            <Link to='/abastecimentoForm'>
                <Button label='Cadastro abastecimento' icon='pi pi-plus' className='p-button-success p-mr-2' />
            </Link>
        );
    };

    return (
        <div className='datatable-crud-demo'>
            <Toolbar className='p-mb-4' left={leftAbastecimentoToolbar}></Toolbar>

            <Toast ref={toast} />

        </div>
    );
}
export default AbastecimentoList;